import React from 'react'

const VehicleBulkUpload = () => {
  return (
    <div>
      <h1>Bulk Upload</h1>
    </div>
  )
}

export default VehicleBulkUpload
